import { createMeta } from "@holigral/shared/seo"

export const meta = createMeta("Profiling.app")
